const defaultState = {};

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_BUSINESS':
      return action.business;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/business.js